import React from 'react';
import { formatAddress, formatNumber } from '../utils/constants';
import '../styles/Header.css';

const Header = ({ 
  selectedNetwork, 
  setSelectedNetwork, 
  account, 
  userInfo, 
  tokenBalance, 
  activeTab, 
  setActiveTab, 
  isAdmin,
  onWalletConnect,
  onWalletDisconnect,
  onWalletError,
  onChainChanged
}) => {

  const tabs = [
    { id: 'dashboard', label: 'Dashboard', icon: '📊' },
    { id: 'stake', label: 'Stake', icon: '💰' },
    { id: 'investments', label: 'Investments', icon: '📈' },
    { id: 'team', label: 'Team', icon: '👥' },
    { id: 'rank', label: 'Rank', icon: '🏆' },
  ];

  if (isAdmin) {
    tabs.push({ id: 'admin', label: 'Admin', icon: '⚙️' });
  }

  return (
    <header className="header">
      {/* Main Header with Logo, User Info, and Wallet */}
      <div className="header-main">
        <div className="header-left">
          <div className="logo">
            <img src="/logo.png" alt="Trail Logo" className="logo-image" onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }} />
            <div className="logo-fallback" style={{ display: 'none' }}>
              <span className="logo-icon">🚀</span>
            </div>
            <span className="logo-text">TRAIL - AI DEFI STAKING</span>
          </div>
        </div>

        <div className="header-center">
          {/* Empty center space for clean header */}
        </div>

        
      </div>

      {/* Navigation Menu - Only show when connected */}
      {account && (
        <div className="nav-section">
          <nav className="nav-tabs">
            {tabs.map(tab => (
              <button
                key={tab.id}
                className={`nav-tab ${activeTab === tab.id ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
              >
                <span className="tab-icon">{tab.icon}</span>
                <span className="tab-label">{tab.label}</span>
              </button>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;